import { fetchWithTimeout, processApiResponse } from "@/core/utils";

interface FlightSearchParams {
  departureDate: string;
  originAirport: string;
  destinationAirport: string;
}

const flightApi = {
  searchFlights: async ({
    departureDate,
    originAirport,
    destinationAirport,
  }: FlightSearchParams) => {
    const queryParams = new URLSearchParams({
      departureDate,
      originAirport,
      destinationAirport,
    });

    const endpoint: string = `api/flight/search?${queryParams}`;

    const response: Response = await fetchWithTimeout(endpoint);
    return processApiResponse(response);
  },

  verifyAirportByFlightNumber: async ({
    departureDate,
    flightNumber,
    departureAirport,
    arrivalAirport,
  }: {
    departureDate: string;
    flightNumber: string;
    departureAirport: string;
    arrivalAirport: string;
  }) => {
    const queryParams = new URLSearchParams({
      departureDate,
      flightNumber,
      departureAirport,
      arrivalAirport,
    });

    const endpoint: string = `api/verifyAirport?${queryParams}`;

    const response: Response = await fetchWithTimeout(endpoint);
    return processApiResponse(response);
  },
};

export { flightApi };
